import React from "react";
import { Box, TextField } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const TextFieldPlaceholder = () => {
  return (
    <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
      <PreviewAndEditor
        title={"TextField with placeholder"}
        language={"js"}
        value={
          '     <TextField placeholder="Placeholder" label="Outlined" />\n' +
          '      <TextField placeholder="Placeholder" label="Filled" variant="filled" />\n' +
          '      <TextField placeholder="Placeholder" label="Standard" variant="standard" />'
        }
      >
        <TextField placeholder="Placeholder" label="Outlined" />
        <TextField placeholder="Placeholder" label="Filled" variant="filled" />
        <TextField
          placeholder="Placeholder"
          label="Standard"
          variant="standard"
        />
      </PreviewAndEditor>
    </Box>
  );
};

export default TextFieldPlaceholder;
